var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "savingsCalculatorInner" } }, [
    _c(
      "div",
      { staticClass: "visible-lte-large", attrs: { id: "savingsResults" } },
      [
        _c("h1", [_vm._v("Savings Calculator")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Enter your averages to calculate how much Gadzoom will save your company in time and overhead."
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "total-savings" }, [
          _c(
            "div",
            { staticClass: "savings" },
            [
              _vm._v(
                _vm._s(
                  _vm._f("asDollars")(_vm.ahasSavings + _vm.plansSavings)
                ) + "\n                "
              ),
              _vm.shouldShowPlus ? [_vm._v("+")] : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "label" }, [
            _vm._v("Average Savings Per Year"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "specific-savings" }, [
          _c("div", { staticClass: "plan-savings" }, [
            _c("div", { staticClass: "label" }, [_vm._v("Plan Savings")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "savings" },
              [
                _vm._v(
                  _vm._s(_vm._f("asDollars")(_vm.plansSavings)) +
                    "\n                    "
                ),
                _vm.shouldShowPlus ? [_vm._v("+")] : _vm._e(),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "aha-savings" }, [
            _c("div", { staticClass: "label" }, [_vm._v("Aha Savings")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "savings" },
              [
                _vm._v(
                  _vm._s(_vm._f("asDollars")(_vm.ahasSavings)) +
                    "\n                    "
                ),
                _vm.shouldShowPlus ? [_vm._v("+")] : _vm._e(),
              ],
              2
            ),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "calculator" },
      [
        _c("h2", [_vm._v("Projects per year")]),
        _vm._v(" "),
        _c("RangePicker", { attrs: { model: _vm.projectsPerYear } }, [
          _vm._v(
            "\n            Approximately how many projects are you awarded each year?\n        "
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("Plans per project")]),
        _vm._v(" "),
        _c("RangePicker", { attrs: { model: _vm.plansPerProject } }, [
          _vm._v("\n            How many plans ("),
          _c("a", { attrs: { href: "/accident-prevention-plan" } }, [
            _vm._v("Accident Prevention Plans"),
          ]),
          _vm._v(", "),
          _c("a", { attrs: { href: "/quality-control-plan" } }, [
            _vm._v("QC Plans"),
          ]),
          _vm._v(", "),
          _c("a", { attrs: { href: "/environmental-protection-plan" } }, [
            _vm._v("Environmental\n            Plans"),
          ]),
          _vm._v(", "),
          _c("a", { attrs: { href: "/documents" } }, [
            _vm._v("Demolition Plans, Confined Space Entry Plans, etc."),
          ]),
          _vm._v(") do you average\n            on each project?\n        "),
        ]),
        _vm._v(" "),
        _c("RangePicker", { attrs: { model: _vm.daysPerPlan } }, [
          _vm._v("\n            Average time to produce each plan?\n        "),
        ]),
        _vm._v(" "),
        _c("RangePicker", { attrs: { model: _vm.costPerHourForPlans } }, [
          _vm._v(
            "\n            Average hourly cost for persons creating plans?\n        "
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("AHAs per project")]),
        _vm._v(" "),
        _c("RangePicker", { attrs: { model: _vm.ahasPerProject } }, [
          _vm._v(
            "\n            How many AHAs do you average on each project?\n        "
          ),
        ]),
        _vm._v(" "),
        _c("RangePicker", { attrs: { model: _vm.daysPerAha } }, [
          _vm._v("\n            Average time to produce each AHA?\n        "),
        ]),
        _vm._v(" "),
        _c("RangePicker", { attrs: { model: _vm.costPerHourForAhas } }, [
          _vm._v(
            "\n            Average hourly cost for persons creating AHAs?\n        "
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "visible-gt-large-flex sidebar" }, [
      _c("div", { attrs: { id: "savingsResults" } }, [
        _c("h1", [_vm._v("Savings Calculator")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Enter your averages to calculate how much Gadzoom will save your company in time and overhead."
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "total-savings" }, [
          _c(
            "div",
            { staticClass: "savings" },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm._f("asDollars")(_vm.ahasSavings + _vm.plansSavings)
                  )
              ),
              _vm.shouldShowPlus ? [_vm._v("+")] : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "label" }, [
            _vm._v("Average Savings Per Year"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "specific-savings" }, [
          _c("div", { staticClass: "plan-savings" }, [
            _c("div", { staticClass: "label" }, [_vm._v("Plan Savings")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "savings" },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm._f("asDollars")(_vm.plansSavings))
                ),
                _vm.shouldShowPlus ? [_vm._v("+")] : _vm._e(),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "aha-savings" }, [
            _c("div", { staticClass: "label" }, [_vm._v("Aha Savings")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "savings" },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm._f("asDollars")(_vm.ahasSavings))
                ),
                _vm.shouldShowPlus ? [_vm._v("+")] : _vm._e(),
              ],
              2
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "filler" }),
    ]),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cta" }, [
      _c("h3", [_vm._v("Sign up for a free demo!")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Gadzoom is a cloud-based program that makes your company's administrative plans for government\n                construction projects fast, accurate, and efficient."
        ),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "lib-button bg-gold full-width",
          attrs: { href: "/demo-request" },
        },
        [_vm._v("Schedule A Demo Now")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "visible-lte-large cta" }, [
      _c("h3", [_vm._v("Sign up for a free demo!")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Gadzoom is a cloud-based program that makes your company's administrative plans for government\n            construction projects fast, accurate, and efficient."
        ),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "lib-button bg-gold full-width",
          attrs: { href: "/demo-request" },
        },
        [_vm._v("Schedule A Demo Now")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }